export default "__VITE_ASSET__DsQ7vC$T__"